import axios from 'axios'

import { config } from 'config'
import {
  requestAuthMiddleware,
  requestScenarioSelectorMiddleware,
  requestSerializationMiddleware,
  responseMiddlewareSuccess,
  responseMiddlewareError,
} from '../middlewares'

const isEnableMock = process.env.REACT_APP_ENABLE_MOCK

const { coreApiUrl } = config.apiGateway
const coreApi = axios.create({
  baseURL: coreApiUrl,
})

coreApi.interceptors.request.use(requestAuthMiddleware)

coreApi.interceptors.request.use(requestSerializationMiddleware)

if (isEnableMock) {
  coreApi.interceptors.request.use(requestScenarioSelectorMiddleware)
}

coreApi.interceptors.response.use(
  responseMiddlewareSuccess,
  responseMiddlewareError,
)

export { coreApi }
